import React, { useState } from "react";
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import "./style.css";
import SVG from "react-inlinesvg";
import { BlockOrg } from "../../../../RoleChecker";
import { ProjectVideoForm } from "./ProjectVideoForm"; // Ubah nama komponen form untuk menangani video
import { useSelector } from "react-redux";

export default function ProjectMedia({
  uploadProjectVideo,
  videos = [],
  removeVideo,
  deletedVideos = [],
  deleteVideos
}) {
  const blockOrg = BlockOrg();
  const { actionsLoading } = useSelector(({ project }) => ({
    actionsLoading: project.actionsLoading
  }));

  const [showVideoModal, setShowVideoModal] = useState(false);

  return (
    <>
      {blockOrg && (
        <ProjectVideoForm
          show={showVideoModal}
          onHide={() => setShowVideoModal(false)}
          loading={actionsLoading}
          submit={uploadProjectVideo}
        />
      )}
      <Card>
        <CardHeader title="Video">
          {" "}
          {/* Ganti judul sesuai dengan jenis media yang ditangani */}
          <CardHeaderToolbar>
            {blockOrg && (
              <button
                className="btn btn-primary mr-2"
                onClick={() => setShowVideoModal(true)}
              >
                Tambah Video
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center"
            }}
          >
            {videos.map(item => (
              <div
                className="d-flex flex-column"
                style={{
                  flex: "0 1 23%",
                  margin: 4,
                  textAlign: "center"
                }}
              >
                <div
                  style={{
                    position: "relative"
                  }}
                >
                  <video
                    width="180" // Atur lebar sesuai kebutuhan
                    height="100" // Atur tinggi sesuai kebutuhan
                    controls
                  >
                    <source
                      src={`${item.storage}/${item.path}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                  {blockOrg && (
                    <div className="video-tool">
                      <label
                        title="Delete video"
                        className="btn btn-icon btn-light btn-hover-danger btn-sm"
                        onClick={() => removeVideo(item)}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-danger">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/General/Trash.svg"
                            )}
                          />
                        </span>
                      </label>
                    </div>
                  )}
                </div>
                <h5 className="h5 mt-2">
                  {(item.project_file && item.project_file.caption) ?? ""}
                </h5>
              </div>
            ))}
          </div>
        </CardBody>
        <CardFooter>
          {deletedVideos.length > 0 && (
            <button
              className="btn btn-danger float-right"
              onClick={deleteVideos}
            >
              Hapus ({deletedVideos.length})
            </button>
          )}
        </CardFooter>
      </Card>
    </>
  );
}
